import {EditBaseCtrl} from "./EditBaseCtrl";
import {Employee} from '../../entities/Employee'
import { StateService, StateParams } from "@uirouter/angularjs";
import {NotificationService} from "../../services/NotificationService";
import {EditEmployeeModel} from "../../models/edit/EditEmployeeModel";

export class EditEmployeeCtrl extends EditBaseCtrl<Employee>{
    public static $inject = ['$scope','$state','$stateParams','$uibModal','NotificationService','EditEmployeeModel'];
    employeeModel:EditEmployeeModel;
    constructor($scope:any,
                stateService:StateService,
                stateParamsService:StateParams,
                public modal:angular.ui.bootstrap.IModalService,
                public notifyService:NotificationService,
                model:EditEmployeeModel) {
        super($scope,stateService,stateParamsService,notifyService,model);
        this.employeeModel = model;
        this.loadData().then((ok)=>{
        });
    }
    pagingRoute():string{
        return "admin.employees";
    }
    openPrintDialog(): void {
        if (this.model.entity.id == null && (this.model.entity.firstName == null || this.model.entity.firstName.length == 0)) {
            alert("Please enter the employee name first before printing.");
            return;
        }
        var modalInstance: angular.ui.bootstrap.IModalServiceInstance = this.modal.open({
            animation: true,
            template: require('../../../views/admin.print.html').default,
            controller: 'PrintCtrl',
            size: 'lg',
            resolve: {
                totalCount: function () {
                    return 1;
                },
                templateType: function () {
                    return "Employee"
                }
            }
        });
        modalInstance.result.then((printer) => {
            this.employeeModel.print(printer);
        })
    }
}
